module.exports = __webpack_public_path__ + "static/media/mazya final edit shot 01.2f87ee9b.webp";